import { trackForm } from '$lib/gtm/event-trigger';
import { GtmEventNames } from '$lib/gtm/types';

type Event = {
  sent: boolean;
  repeatable: boolean;
};

type TrackingEvents = {
  show: Event;
  start: Event;
  complete: Event;
  error: Event;
  submit: Event;
};

type Extras = {
  error_type?: string;
  error_message?: string;
};

function trackEvent(
  type: keyof TrackingEvents,
  trackingEvents: TrackingEvents,
  form: string,
  variant: string,
  extras?: Extras,
  isCompleted?: () => boolean,
) {
  const event = trackingEvents[type];

  if (!event.repeatable && event.sent) {
    return false;
  }

  if (isCompleted && !isCompleted()) {
    return false;
  }

  trackForm({
    event: GtmEventNames.FormInteraction,
    event_params: {
      event_action: `${form}_${type}`,
      event_group: form,
      event_variant: variant,
      ...extras,
    },
  });

  event.sent = true;
}

export const getGtmFormTracker = (form: string, variant: string) => {
  const trackingEvents: TrackingEvents = {
    show: { sent: false, repeatable: false },
    start: { sent: false, repeatable: false },
    complete: { sent: false, repeatable: false },
    error: { sent: false, repeatable: true },
    submit: { sent: false, repeatable: true },
  };

  trackEvent('show', trackingEvents, form, variant);

  return {
    sendTrackingEvent(type: keyof TrackingEvents, errorMessage?: string) {
      const extras: Extras = {};
      if (type == 'error') {
        extras.error_type = 'server_error';
        extras.error_message = errorMessage;
      }

      trackEvent(type, trackingEvents, form, variant, extras);
    },
    onFormInputEvent(isCompleted?: () => boolean) {
      trackEvent('start', trackingEvents, form, variant);
      trackEvent('complete', trackingEvents, form, variant, {}, isCompleted);
    },
  };
};
